// extracted by css-extract-rspack-plugin
export default {"sizeFluid":"100%","loader":"loader__loader___ZyiES"};